import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  CareLocation1v3u5wduz023s as CareLocation,
  ID1m87d1hextx54 as ID,
  CareLocationType_Center_getInstance2f47v0wni4mas as CareLocationType_Center_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import { get_provider1s9y5fs8n0r3w as get_provider } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import {
  addClosureDialogmoz60sf1yaca as addClosureDialog,
  addLocationDialog2nfoxx4583r7s as addLocationDialog,
} from '../locations/locationComponents.mjs';
import { LocationDetailPage2zka4ek7qyuhq as LocationDetailPage } from '../locations/LocationDetailPage.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { Draft3goc8q7vggbic as Draft } from '../../extensions/Draft.ext.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Addresspdncepxooezp as Address } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { Draftj5auffrm1u2b as Draft_0 } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  iconButton2nzpucy7a6ixd as iconButton,
  reactiveLabel206b3aonybuoa as reactiveLabel,
  addButton16duilic9iyqp as addButton,
} from '../components/view-utilities.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit5ty08lpw30d6 as get_edit } from '../../icons.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  PhoneNumber__toString_impl_7i2x3q2my82bpxyutrq as PhoneNumber__toString_impl_7i2x3q,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { styledHeaderwng1nfqibdig as styledHeader } from '../../theme/semantics.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { text189ciz0cnr32o as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { SingleDaysPage2w42wjhncrkcq as SingleDaysPage } from '../reports/SingleDaysPage.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ReportFiltersigb451dg4asm as ReportFilters } from '../reports/ReportFilters.mjs';
import {
  DayTotalsPage3tkd9ei9dl3us as DayTotalsPage,
  DayGrouping_Location_getInstancedo19cuuiy558 as DayGrouping_Location_getInstance,
} from '../reports/DayTotalsPage.mjs';
import {
  PlacementTotalsPage1pmi1f9h9gb4a as PlacementTotalsPage,
  PlacementGrouping_Location_getInstanceajmolhamx7a as PlacementGrouping_Location_getInstance,
} from '../reports/PlacementTotalsPage.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  table1wgqnzrzsmc0y as table,
} from '../components/table.mjs';
import { providerForm1foiubykcediz as providerForm } from './providerComponents.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, ProviderDetailPage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, ProviderDetailPage$actionBar$slambda($this));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, ProviderDetailPage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Save provider', VOID, VOID, VOID, VOID, VOID, ProviderDetailPage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function ProviderDetailPage$provider$lambda($this$Draft) {
  return $this$Draft.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$();
}
function ProviderDetailPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerDetailsHeading_vbtsje_k$();
}
function ProviderDetailPage$render$lambda_0($this$iconButton) {
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerEditButtonDescription_6z204a_k$();
}
function ProviderDetailPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.editMode_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function ProviderDetailPage$render$lambda_1($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerOffersTransportationLabel_8w5t13_k$();
}
function ProviderDetailPage$render$lambda_2($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerVendorNumberLabel_cg5mi1_k$();
}
function ProviderDetailPage$render$lambda_3($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactNameLabel_l558ot_k$();
}
function ProviderDetailPage$render$lambda_4($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactEmailLabel_lc4wv2_k$();
}
function ProviderDetailPage$render$lambda_5($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactPhoneLabel_umwegk_k$();
}
function ProviderDetailPage$render$lambda_6($this$styledHeader) {
  return 'Reports';
}
function ProviderDetailPage$render$lambda_7($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerLocationsHeading_kilnxe_k$();
}
function ProviderDetailPage$render$lambda_8($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function ProviderDetailPage$render$lambda_9($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddClosuresButton_8pcv03_k$();
}
function ProviderDetailPage$render$lambda$slambda_0(this$0, $this_addButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_careLocations_f1rtw_k$();
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp$ret$1 = eq(get_provider(it), new (ID())(this$0.id_1));
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = tmp.query_so6xq1_k$(new (Query())(tmp$ret$1, VOID, VOID, 30000));
    var locations = yield* await_0(this_1, $completion);
    addClosureDialog(this$0, $this_addButton.get_context_h02k06_k$(), locations);
    return Unit_instance;
  }), 1);
}
function ProviderDetailPage$render$lambda_10($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function ProviderDetailPage$render$lambda_11($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerAddLocationButtonLabel_ny6cyi_k$();
}
function ProviderDetailPage$render$lambda$slambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.location_1.set_revjhg_k$(this$0.emptyLocation_1, $completion);
    return Unit_instance;
  }), 0);
}
function ProviderDetailPage$render$lambda$slambda_1(this$0, $this_addButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $this_addButton.get_context_h02k06_k$();
    addLocationDialog(this$0, tmp, this$0.location_1, ProviderDetailPage$render$lambda$slambda$slambda(this$0));
    return Unit_instance;
  }), 1);
}
function ProviderDetailPage$render$lambda_12(it) {
  return new (LocationDetailPage())(it._id_1);
}
function ProviderDetailPage$render$lambda_13($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerNameLabel_yl378x_k$();
}
function ProviderDetailPage$render$lambda_14($this$text, it) {
  return it.name_1;
}
function ProviderDetailPage$render$lambda_15($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerCityLabel_2978ep_k$();
}
function ProviderDetailPage$render$lambda_16($this$text, it) {
  return it.address_1.toCityState_srlsgl_k$();
}
function ProviderDetailPage$render$lambda_17($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactLabel_6n76gi_k$();
}
function ProviderDetailPage$render$lambda_18($this$text, it) {
  return it.contact_1.name_1;
}
function ProviderDetailPage$render$lambda_19($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function ProviderDetailPage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function ProviderDetailPage$actionBar$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.provider_1.cancel_2l89ey_k$();
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    return Unit_instance;
  }), 0);
}
function ProviderDetailPage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerSaveButtonLabel_8m3k6t_k$();
}
function ProviderDetailPage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.provider_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    yield* this$0.provider_1.publish_xq9q2e_k$($completion);
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp$ret$2 = yield* await_1(this_1, $completion);
    toast(tmp_0, tmp$ret$2.get_providerSavedToast_yjdohm_k$());
    return Unit_instance;
  }), 1);
}
var ProviderDetailPageClass;
function ProviderDetailPage() {
  if (ProviderDetailPageClass === VOID) {
    class $ extends Form() {
      constructor(id) {
        super();
        this.id_1 = id;
        var tmp = this;
        tmp.provider_1 = validated(Draft(new (ID())(this.id_1), ProviderDetailPage$provider$lambda));
        var tmp_0 = this;
        tmp_0.locationsData_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$3);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$7);
          var tmp$ret$4 = eq(get_provider(it), new (ID())(this.id_1));
          var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
          return tmp.query_so6xq1_k$(tmp$ret$0);
        });
        this.emptyLocation_1 = new (CareLocation())(VOID, this.id_1, '', CareLocationType_Center_getInstance(), '', new (Address())('', VOID, '', ''));
        var tmp_1 = this;
        tmp_1.location_1 = validated(Draft_0(($this$Draft) => this.emptyLocation_1));
        this.editMode_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.provider_1).name_1);
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.provider_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.provider_1).name_1);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_5 = themed(element_2, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowOrCol())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_3.willAddChild_hz2iwc_k$(element_4);
        element_4.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_6 = get_centered(element_4);
        var tmp$ret$29 = weight(this_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_7 = get_bold(tmp$ret$29);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_7.willAddChild_hz2iwc_k$(element_5);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_4, ProviderDetailPage$render$lambda);
        element_5.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_5);
        var tmp_5 = get_centered(element_4);
        var tmp_6 = shownWhen(tmp_5, false, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.let' call
          var it = $this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull());
          return $this$shownWhen.invoke_r7m7el_k$(it.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(it.managedProviders_1).contains_aljjnj_k$(new (ID())(this.id_1));
        });
        var tmp_7 = get_edit(Companion_getInstance_0());
        var tmp_8 = ProviderDetailPage$render$lambda_0;
        iconButton(tmp_6, tmp_7, tmp_8, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, ProviderDetailPage$render$lambda$slambda(this));
          return Unit_instance;
        });
        element_4.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (RowOrCol())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element_3.willAddChild_hz2iwc_k$(element_6);
        element_6.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_8 = weight(element_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_8.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(true);
        var tmp_9 = ProviderDetailPage$render$lambda_1;
        reactiveLabel(element_7, tmp_9, ($this$reactiveLabel) => $this$reactiveLabel.invoke_r7m7el_k$(this.provider_1).offersTransportation_1 ? $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerYesLabel_su34fb_k$() : $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerNoLabel_wn67vr_k$());
        var tmp_10 = ProviderDetailPage$render$lambda_2;
        reactiveLabel(element_7, tmp_10, ($this$reactiveLabel) => {
          var tmp0_elvis_lhs = $this$reactiveLabel.invoke_r7m7el_k$(this.provider_1).vendorNumber_1;
          return tmp0_elvis_lhs == null ? $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerVendorNumberNotSet_vxdl2y_k$() : tmp0_elvis_lhs;
        });
        element_7.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (Separator())(element_6.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        element_6.willAddChild_hz2iwc_k$(element_8);
        element_8.onStartup_vrxh3i_k$();
        element_6.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_9 = weight(element_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_9.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(true);
        var tmp_11 = ProviderDetailPage$render$lambda_3;
        reactiveLabel(element_9, tmp_11, ($this$reactiveLabel) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = $this$reactiveLabel.invoke_r7m7el_k$(this.provider_1).contact_1.name_1;
          var tmp;
          if (isBlank(this_0)) {
            tmp = '[Not set]';
          } else {
            tmp = this_0;
          }
          return tmp;
        });
        var tmp_12 = ProviderDetailPage$render$lambda_4;
        reactiveLabel(element_9, tmp_12, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.provider_1).contact_1.email_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = EmailAddress__toString_impl_artjh3(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? '[Not set]' : tmp1_elvis_lhs;
        });
        var tmp_13 = ProviderDetailPage$render$lambda_5;
        reactiveLabel(element_9, tmp_13, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.provider_1).contact_1.phone_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (PhoneNumber())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = PhoneNumber__toString_impl_7i2x3q(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? '[Not set]' : tmp1_elvis_lhs;
        });
        element_9.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_9);
        element_6.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_6);
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.let' call
          var it = $this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull());
          return $this$shownWhen.invoke_r7m7el_k$(it.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(it.managedProviders_1).contains_aljjnj_k$(new (ID())(this.id_1));
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_10.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (Space())(element_10.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        element_10.willAddChild_hz2iwc_k$(element_11);
        element_11.onStartup_vrxh3i_k$();
        element_10.addChild_2qpft2_k$(element_11);
        styledHeader(element_10, ProviderDetailPage$render$lambda_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(element_10.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element_10.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_11 = themed(element_12, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (Link())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_11.willAddChild_hz2iwc_k$(element_13);
        text(element_13, 'Remittance breakdown');
        var tmp_14 = KMutableProperty0();
        var tmp_15 = Link$_get_to_$ref_jq7esp(element_13);
        var tmp_16 = getPropertyCallableRef('to', 0, tmp_14, tmp_15, Link$_set_to_$ref_i9gu5x(element_13));
        element_13.invoke_bnq13k_k$(tmp_16, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (SingleDaysPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, VOID, VOID, VOID, setOf(new (ID())(this.id_1))));
          return this_0;
        });
        element_13.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_13);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_12 = themed(element_12, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (Link())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_12.willAddChild_hz2iwc_k$(element_14);
        text(element_14, 'Totals by location');
        var tmp_17 = KMutableProperty0();
        var tmp_18 = Link$_get_to_$ref_jq7esp(element_14);
        var tmp_19 = getPropertyCallableRef('to', 0, tmp_17, tmp_18, Link$_set_to_$ref_i9gu5x(element_14));
        element_14.invoke_bnq13k_k$(tmp_19, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (DayTotalsPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, VOID, VOID, VOID, setOf(new (ID())(this.id_1))));
          this_0.groupBy_1.set_value_v1vabv_k$(DayGrouping_Location_getInstance());
          return this_0;
        });
        element_14.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_13 = themed(element_12, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Link())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_13.willAddChild_hz2iwc_k$(element_15);
        text(element_15, 'Enrollment');
        var tmp_20 = KMutableProperty0();
        var tmp_21 = Link$_get_to_$ref_jq7esp(element_15);
        var tmp_22 = getPropertyCallableRef('to', 0, tmp_20, tmp_21, Link$_set_to_$ref_i9gu5x(element_15));
        element_15.invoke_bnq13k_k$(tmp_22, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (PlacementTotalsPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, VOID, VOID, VOID, setOf(new (ID())(this.id_1))));
          this_0.groupBy_1.set_value_v1vabv_k$(PlacementGrouping_Location_getInstance());
          return this_0;
        });
        element_15.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_15);
        element_12.onStartup_vrxh3i_k$();
        element_10.addChild_2qpft2_k$(element_12);
        element_10.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (Space())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        element_2.willAddChild_hz2iwc_k$(element_16);
        element_16.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_16);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (RowOrCol())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        element_2.willAddChild_hz2iwc_k$(element_17);
        element_17.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_14 = get_atBottomStart(element_17);
        var tmp_23 = weight(this_14, 1.0);
        styledHeader(tmp_23, ProviderDetailPage$render$lambda_7);
        var tmp_24 = get_centered(element_17);
        var tmp_25 = shownWhen(tmp_24, false, VOID, ProviderDetailPage$render$lambda_8);
        var tmp_26 = ProviderDetailPage$render$lambda_9;
        addButton(tmp_25, tmp_26, ($this$addButton) => {
          $this$addButton.set_action_2ds022_k$(Action('Add closures', VOID, VOID, VOID, VOID, VOID, ProviderDetailPage$render$lambda$slambda_0(this, $this$addButton)));
          return Unit_instance;
        });
        var tmp_27 = get_centered(element_17);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_15 = shownWhen(tmp_27, false, VOID, ProviderDetailPage$render$lambda_10);
        var tmp_28 = themed(this_15, ImportantSemantic_getInstance());
        var tmp_29 = ProviderDetailPage$render$lambda_11;
        addButton(tmp_28, tmp_29, ($this$addButton) => {
          $this$addButton.set_action_2ds022_k$(Action('Add location', VOID, VOID, VOID, VOID, VOID, ProviderDetailPage$render$lambda$slambda_1(this, $this$addButton)));
          return Unit_instance;
        });
        element_17.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_17);
        var tmp_30 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(this.locationsData_1)));
        var tmp_31 = ProviderDetailPage$render$lambda_12;
        var tmp_32 = Companion_instance_0;
        var tmp_33 = ProviderDetailPage$render$lambda_13;
        var tmp_34 = tmp_32.text$default_gwb2zv_k$(tmp_33, VOID, ProviderDetailPage$render$lambda_14);
        var tmp_35 = Companion_instance_0;
        var tmp_36 = ProviderDetailPage$render$lambda_15;
        var tmp_37 = tmp_35.text$default_gwb2zv_k$(tmp_36, VOID, ProviderDetailPage$render$lambda_16);
        var tmp_38 = Companion_instance_0;
        var tmp_39 = ProviderDetailPage$render$lambda_17;
        table(element_2, tmp_30, tmp_31, [tmp_34, tmp_37, tmp_38.text$default_gwb2zv_k$(tmp_39, VOID, ProviderDetailPage$render$lambda_18)]);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_16 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (RowOrCol())(this_16.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_16.willAddChild_hz2iwc_k$(element_18);
        element_18.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (Separator())(element_18.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        element_18.willAddChild_hz2iwc_k$(element_19);
        element_19.onStartup_vrxh3i_k$();
        element_18.addChild_2qpft2_k$(element_19);
        actionBar(this, element_18);
        providerForm(this, element_18, this.provider_1, true);
        actionBar(this, element_18);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (Separator())(element_18.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        element_18.willAddChild_hz2iwc_k$(element_20);
        element_20.onStartup_vrxh3i_k$();
        element_18.addChild_2qpft2_k$(element_20);
        element_18.onStartup_vrxh3i_k$();
        this_16.addChild_2qpft2_k$(element_18);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_17 = shownWhen(element, VOID, VOID, ProviderDetailPage$render$lambda_19);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (Space())(this_17.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_21);
        this_17.willAddChild_hz2iwc_k$(element_21);
        element_21.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_21);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'ProviderDetailPage', VOID, VOID, [Page(), CanBlockBack()]);
    ProviderDetailPageClass = $;
  }
  return ProviderDetailPageClass;
}
//region block: exports
export {
  ProviderDetailPage as ProviderDetailPagemo61e65yggj8,
};
//endregion

//# sourceMappingURL=ProviderDetailPage.mjs.map
